'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$ChatsRead(id) {
  this.Lapp_pages_AppPage$ChatsRead__f_id = null;
  this.Lapp_pages_AppPage$ChatsRead__f_id = id;
}
export { $c_Lapp_pages_AppPage$ChatsRead as $c_Lapp_pages_AppPage$ChatsRead };
$c_Lapp_pages_AppPage$ChatsRead.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$ChatsRead.prototype.constructor = $c_Lapp_pages_AppPage$ChatsRead;
/** @constructor */
function $h_Lapp_pages_AppPage$ChatsRead() {
}
export { $h_Lapp_pages_AppPage$ChatsRead as $h_Lapp_pages_AppPage$ChatsRead };
$h_Lapp_pages_AppPage$ChatsRead.prototype = $c_Lapp_pages_AppPage$ChatsRead.prototype;
$c_Lapp_pages_AppPage$ChatsRead.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1178867300, true);
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$ChatsRead)) {
    var x = this.Lapp_pages_AppPage$ChatsRead__f_id;
    var x$2 = x$0.Lapp_pages_AppPage$ChatsRead__f_id;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.productPrefix__T = (function() {
  return "ChatsRead";
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$ChatsRead__f_id;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$ChatsRead.prototype.id__Ljkugiya_ulid_ULID = (function() {
  return this.Lapp_pages_AppPage$ChatsRead__f_id;
});
function $isArrayOf_Lapp_pages_AppPage$ChatsRead(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$ChatsRead)));
}
export { $isArrayOf_Lapp_pages_AppPage$ChatsRead as $isArrayOf_Lapp_pages_AppPage$ChatsRead };
var $d_Lapp_pages_AppPage$ChatsRead = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$ChatsRead, "app.pages.AppPage$ChatsRead", ({
  Lapp_pages_AppPage$ChatsRead: 1,
  Lapp_pages_AppPage: 1,
  Lapp_pages_AppPage$HasChatId: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$ChatsRead as $d_Lapp_pages_AppPage$ChatsRead };
//# sourceMappingURL=app.pages.-App-Page$-Chats-Read.js.map
